import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import {
    Box,
    Dialog,
    DialogContent,
    DialogContentText,
    IconButton,
    Slide,
    useMediaQuery, useTheme
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

import { List as IList } from 'immutable';
import Typography from '@mui/material/Typography';
import { getSupportedLocales, getBrandElectronicCurrencyList } from '../brand/brandSelectors';
import { getIntlLocale, getIntlCurrencyCode } from '../intl/intlSelectors';

import { setLocale as setLocaleActionCreator, setCurrency as setCurrencyActionCreator } from '../intl/intlModule';

import LanguagePicker from './LanguagePicker';
import currencyLocalMessages from './messages/LocaleCurrencyMessages';

const Transition = React.forwardRef((props, ref) => <Slide direction='up' ref={ref} {...props} />);

const LocalePickerPopup = ({
    intl, isOpen, popupStatus, clickLocation, supportedLocales, selectedLocale, setLocale
}) => {
    const fullySupportedLocales = supportedLocales;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            <Dialog
                open={isOpen}
                className='locale-currency-popup-modal'
                onClose={() => popupStatus(false)}
                scroll='paper'
                TransitionComponent={isMobile ? Transition : undefined}
                fullWidth
                maxWidth='sm'
                aria-labelledby='dialog-title'
            >
                <Box className='currency-locale-heading'>
                    <IconButton aria-label="Close" className='close-currency-locale-modal' onClick={() => popupStatus(false)}>
                        <CloseIcon />
                    </IconButton>
                    <Box className='currency-locale-tabs-wrapper'>
                        <Box
                            className='currency-locale-tabs'
                            sx={{ display: 'inline-block', position: 'relative' }}
                        >
                            {fullySupportedLocales.size > 1 && (
                                <>
                                    <Typography
                                        component='h2'
                                        id='dialog-title'
                                        className='MuiTab-root Mui-selected locale-tab'
                                        sx={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            boxSizing: 'border-box',
                                            minWidth: 90,
                                            minHeight: 48,
                                            paddingTop: '12px',
                                            paddingBottom: '12px',
                                            margin: 0,
                                            fontWeight: 500,
                                            lineHeight: 1.75
                                        }}
                                    >
                                        {intl.formatMessage(currencyLocalMessages.languageLabelText)}
                                    </Typography>
                                    <span
                                        className='MuiTabs-indicator'
                                        style={{
                                            position: 'absolute',
                                            left: 0,
                                            bottom: 0,
                                            width: '100%'
                                        }}
                                    />
                                </>
                            )}
                        </Box>
                    </Box>
                </Box>
                <DialogContent
                    className='tab-content'
                >
                    <DialogContentText>
                        <Box className='currency-locale-wrapper'>
                            {fullySupportedLocales.size > 1 && (
                                <LanguagePicker
                                    intl={intl}
                                    selectedLocale={selectedLocale}
                                    setLocale={setLocale}
                                    localesForSelectedCountry={fullySupportedLocales}
                                    popupStatus={popupStatus}
                                    location={clickLocation}
                                    buttonId="language-picker-button"
                                />
                            )}
                        </Box>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </>
    );
};

LocalePickerPopup.defaultProps = {
    supportedLocales: IList()
};

LocalePickerPopup.propTypes = {
    
    intl: intlShape.isRequired,
    isOpen: PropTypes.bool.isRequired,
    popupStatus: PropTypes.func.isRequired,
    clickLocation: PropTypes.string.isRequired,
    supportedLocales: PropTypes.instanceOf(IList),
    selectedLocale: PropTypes.string.isRequired,
    setLocale: PropTypes.func.isRequired
};

export const mapStateToProps = state => ({
    selectedLocale: getIntlLocale(state),
    selectedCurrency: getIntlCurrencyCode(state),
    supportedLocales: getSupportedLocales(state),
    supportedElectronicCurrencyList: getBrandElectronicCurrencyList(state)
});

export const mapDispatchToProps = {
    setLocale: setLocaleActionCreator,
    setCurrency: setCurrencyActionCreator
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(LocalePickerPopup));
